import { render } from "./AddStaffForm.vue?vue&type=template&id=1407cf7e&scoped=true"
import script from "./AddStaffForm.vue?vue&type=script&lang=js"
export * from "./AddStaffForm.vue?vue&type=script&lang=js"

import "./AddStaffForm.vue?vue&type=style&index=0&id=1407cf7e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1407cf7e"]])

export default __exports__